// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8x-4";
export var collapsed = "_8x-1";
export var headerBar = "_8x-0";
export var leftHeaderContent = "_8x-3";
export var subjectContainer = "_8x-2";